export default __webpack_public_path__ + "static/media/CZAS_IKONA.0a93a3f8.png";